var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { View, Platform } from 'react-native';
import { createStyleSheet } from '../../utils';
import { useStyleSheet } from '../../hooks';
import { IconButton } from '../IconButton';
import { Text } from '../Text';
import { Link } from '../Link';
import { Placeholder } from './components';
import { Participants } from '../Participants';
export const Header = (_a) => {
    var { size, isLoading, title, participants, style, onBack } = _a, props = __rest(_a, ["size", "isLoading", "title", "participants", "style", "onBack"]);
    const styles = useStyleSheet(getStyles);
    if (isLoading)
        return (React.createElement(Placeholder, { style: style, size: size, withBack: !!onBack, action: props.action }));
    return (React.createElement(View, { style: [
            styles.container,
            styles[size],
            onBack ? {} : styles.withoutBack,
            style
        ] },
        onBack ? (React.createElement(IconButton, { type: 'tertiary', accent: 'neutral', value: 'arrow-left', onPress: onBack, style: styles.back, size: 'sm' })) : null,
        onBack ? (title ? (React.createElement(Text, { type: 'headline', size: 'lg' }, title)) : (React.createElement(Participants, { data: participants, limit: Platform.OS !== 'web' ? 2 : 4 }))) : title ? (React.createElement(Text, { type: 'heading', size: 'h4' }, title)) : (React.createElement(Participants, { data: participants, limit: Platform.OS !== 'web' ? 2 : 4 })),
        props.action === 'edit' ? (React.createElement(Link, { type: 'primary', text: props.isEditing ? 'Done' : 'Edit', onPress: props.isEditing ? props.onDoneEditing : props.onEdit, style: styles.edit })) : props.action === 'custom' ? (React.createElement(View, { style: styles.controls }, props.controls
            ? props.controls.map((action, index) => (React.createElement(IconButton, { key: action.icon, type: 'tertiary', accent: 'neutral', value: action.icon, onPress: action.onPress, style: index !== 0 ? styles.controlWithMargin : {}, size: 'sm' })))
            : props.children)) : null));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: size.B
    },
    lg: {
        height: 65
    },
    md: {
        height: 61
    },
    withoutBack: {
        justifyContent: 'flex-start',
        paddingLeft: size.E
    },
    controls: {
        flexDirection: 'row',
        position: 'absolute',
        right: size.B
    },
    controlWithMargin: { marginLeft: size.C },
    edit: {
        position: 'absolute',
        right: size.E
    },
    back: {
        position: 'absolute',
        left: size.B
    }
}));
//# sourceMappingURL=index.js.map